/**
 * A phone number as typed ("+39 333 123 4567") in the form the API keeps
 * (E.164): the booking's form and the record's correction say it one way.
 */
export const e164 = (phone: string) => phone.replace(/[\s().-]/g, '')
